var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
{
    /*  */
}
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
// #F15700
function SearchIcon(_a) {
    var { fillColor } = _a, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", Object.assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { id: "search_FILL0_wght400_GRAD0_opsz48 (2) 1" },
            React.createElement("path", { id: "Vector", d: "M16.5833 17.4792L11.1042 12C10.6875 12.3611 10.2017 12.6424 9.64669 12.8438C9.0917 13.0452 8.50114 13.1459 7.875 13.1459C6.37275 13.1459 5.10135 12.625 4.06081 11.5834C3.02027 10.5417 2.5 9.28474 2.5 7.81252C2.5 6.3403 3.02083 5.08335 4.0625 4.04169C5.10417 3.00002 6.36458 2.47919 7.84375 2.47919C9.32292 2.47919 10.5799 3.00002 11.6146 4.04169C12.6493 5.08335 13.1667 6.34134 13.1667 7.81565C13.1667 8.41078 13.0694 8.98613 12.875 9.54169C12.6806 10.0972 12.3889 10.6181 12 11.1042L17.5 16.5625L16.5833 17.4792ZM7.85417 11.8959C8.98264 11.8959 9.94184 11.4965 10.7318 10.6979C11.5217 9.89933 11.9167 8.93752 11.9167 7.81252C11.9167 6.68752 11.5217 5.72571 10.7318 4.9271C9.94184 4.12849 8.98264 3.72919 7.85417 3.72919C6.71413 3.72919 5.74508 4.12849 4.94704 4.9271C4.14901 5.72571 3.75 6.68752 3.75 7.81252C3.75 8.93752 4.14901 9.89933 4.94704 10.6979C5.74508 11.4965 6.71413 11.8959 7.85417 11.8959Z", fill: fillColor }))));
}
export default memo(withIconDefaults(SearchIcon));
